import api from '@/api/services/api'

const getCollection = params => api({
  method: 'get',
  url: 'flights/search',
  params
})

const getFlightTarrifs = params => api({
  method: 'get',
  url: '/flights/branded',
  params
})

const getFlightRules = params => api({
  method: 'get',
  url: '/flights/rules',
  params
})

const getFlightQuotasDates = params => api({
  method: 'get',
  url: '/flights/quotas',
  params
})

const getFlightCalendar = params => api({
  method: 'get',
  url: '/flights/calendar',
  params
})

export {
  getCollection,
  getFlightTarrifs,
  getFlightRules,
  getFlightQuotasDates,
  getFlightCalendar
}